/* eslint-disable react/prop-types */
import { useState } from "react";
import { Alert, Box, Button, Checkbox, CircularProgress, FormControlLabel, FormGroup, FormLabel, Stack, TextField, Typography, } from "@mui/material";
import { useGetInquiryTypes, usePostInquiries, } from "../generated/queries/queries"; // adjust to wherever your generated hooks live
import React from "react";
const INITIAL_FORM_STATE = {
    first_name: "",
    last_name: "",
    email: "",
    location: "",
    message: "",
    hear_about_me: "",
    date_description: "",
    website: "",
};
export default function InquiryForm() {
    const [formData, setFormData] = useState(INITIAL_FORM_STATE);
    const [selectedTypeIds, setSelectedTypeIds] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    // react-query handles loading/error/caching for the checkbox options.
    const { data: inquiryTypes = [], isLoading: typesLoading, error: typesError, } = useGetInquiryTypes();
    // The mutation hook gives you pending/error state directly — no manual
    // setSubmitting/setSubmitError bookkeeping needed.
    const { mutate: submitInquiry, isPending: submitting, error: submitError, } = usePostInquiries();
    const handleFieldChange = (field) => (event) => {
        setFormData((prev) => ({ ...prev, [field]: event.target.value }));
    };
    const handleTypeToggle = (typeId) => (event) => {
        setSelectedTypeIds((prev) => event.target.checked
            ? [...prev, typeId]
            : prev.filter((id) => id !== typeId));
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        // NOTE: the generated PostInquiriesData shape depends on your
        // types.gen.ts — hey-api/client-axios usually expects the request body
        // under a `body` key (i.e. { body: {...} }). Check PostInquiriesData in
        // requests/types.gen.ts and adjust this shape if it differs (e.g. if it's
        // a flat object instead of { body }).
        submitInquiry({
            body: {
                ...formData,
                interest_type_ids: selectedTypeIds,
            },
        }, {
            onSuccess: () => {
                setSubmitted(true);
                setFormData(INITIAL_FORM_STATE);
                setSelectedTypeIds([]);
            },
        });
    };
    if (submitted) {
        return (React.createElement(Alert, { severity: "success", sx: { maxWidth: 600, mx: "auto" } }, "Thanks for reaching out! I'll get back to you soon."));
    }
    return (React.createElement(Box, { component: "form", onSubmit: handleSubmit, sx: { maxWidth: 600, mx: "auto", p: 2 } },
        React.createElement(Typography, { sx: {
                fontSize: { xs: 20, md: 24 },
                lineHeight: 1.5,
            }, variant: "h5", gutterBottom: true }, "Get in Touch"),
        React.createElement(Stack, { spacing: 2 },
            React.createElement(Stack, { direction: { xs: "column", sm: "row" }, spacing: 2 },
                React.createElement(TextField, { label: "First Name", value: formData.first_name, onChange: handleFieldChange("first_name"), required: true, fullWidth: true }),
                React.createElement(TextField, { label: "Last Name", value: formData.last_name, onChange: handleFieldChange("last_name"), required: true, fullWidth: true })),
            React.createElement(TextField, { label: "Email", type: "email", value: formData.email, onChange: handleFieldChange("email"), required: true, fullWidth: true }),
            React.createElement(TextField, { label: "Location", value: formData.location, onChange: handleFieldChange("location"), required: true, fullWidth: true, helperText: "Where would this session take place?" }),
            React.createElement(TextField, { label: "Preferred Date(s)", value: formData.date_description, onChange: handleFieldChange("date_description"), required: true, fullWidth: true, helperText: "Exact date, a season, or 'flexible' all work" }),
            React.createElement(TextField, { label: "How did you hear about me?", value: formData.hear_about_me, onChange: handleFieldChange("hear_about_me"), required: true, fullWidth: true }),
            React.createElement(Box, null,
                React.createElement(FormLabel, { component: "legend", sx: { mb: 1 } }, "What are you interested in?"),
                typesLoading && React.createElement(CircularProgress, { size: 20 }),
                typesError && (React.createElement(Alert, { severity: "error", sx: { mb: 1 } },
                    "Couldn't load session types: ",
                    typesError.message)),
                !typesLoading && !typesError && (React.createElement(FormGroup, null, inquiryTypes.map((type) => (React.createElement(FormControlLabel, { key: type.id, control: React.createElement(Checkbox, { checked: selectedTypeIds.includes(type.id), onChange: handleTypeToggle(type.id) }), label: type.display_label })))))),
            React.createElement(TextField, { label: "Message", value: formData.message, onChange: handleFieldChange("message"), required: true, fullWidth: true, multiline: true, rows: 10 }),
            React.createElement(TextField, { label: "Website", name: "website", value: formData.website, onChange: handleFieldChange("website"), autoComplete: "off", tabIndex: -1, "aria-hidden": "true", sx: {
                    position: "absolute",
                    left: "-9999px",
                    width: "1px",
                    height: "1px",
                    overflow: "hidden",
                } }),
            submitError && (React.createElement(Alert, { severity: "error" }, submitError.response?.data?.message ||
                "Something went wrong submitting your inquiry.")),
            React.createElement(Button, { type: "submit", variant: "contained", size: "large", disabled: submitting }, submitting ? React.createElement(CircularProgress, { size: 24 }) : "Send Inquiry"))));
}
